"use client"

import { Card } from "@/components/ui/card"
import { Label } from "@/components/ui/label"
import { Input } from "@/components/ui/input"
import { Button } from "@/components/ui/button"
import { Menu, Settings } from "lucide-react"
import OrgLayout, { useSidebar } from "@/layouts/OrgLayout"

function GlobalSettings() {
	const {setShowSidebar} = useSidebar()
	return (
		<div className="space-y-6 w-full">
			<div className="flex items-center mt-2 gap-4">
				<Menu className="md:hidden ml-2 h-6 w-6 cursor-pointer" onClick={() => setShowSidebar(true)} />
				<h2 className="text-2xl font-semibold">Global Settings</h2>
			</div>

			<Card className="p-6">
				<div className="space-y-6">
					<div className="flex items-center gap-3 mb-4">
						<div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
							<Settings className="h-5 w-5 text-primary" />
						</div>
						<div>
							<h3 className="font-semibold">System Configuration</h3>
							<p className="text-sm text-muted-foreground">Configure global system settings</p>
						</div>
					</div>

					<div className="space-y-4">
						<div className="space-y-2">
							<Label htmlFor="billing-contact">Billing Contact Email</Label>
							<Input id="billing-contact" type="email" placeholder="billing@company.com" />
						</div>

						<div className="space-y-2">
							<Label htmlFor="notification-email">System Notification Email</Label>
							<Input id="notification-email" type="email" placeholder="notifications@company.com" />
						</div>

						<div className="space-y-2">
							<Label htmlFor="company-name">Company Name</Label>
							<Input id="company-name" placeholder="Acme Healthcare" />
						</div>

						<div className="space-y-2">
							<Label htmlFor="timezone">Default Timezone</Label>
							<Input id="timezone" placeholder="America/New_York" />
						</div>
					</div>

					<div className="flex justify-end pt-4">
						<Button>Save Changes</Button>
					</div>
				</div>
			</Card>
		</div>
	)
}

GlobalSettings.layout = (page: React.ReactNode) => <OrgLayout activeSection="global_settings">{page}</OrgLayout>
export default GlobalSettings
